var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 69,
    viewBox: "0 0 123 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823_10957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 125,
    height: 71
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.715088,
    y: -0.237305,
    width: 124.43,
    height: 69.3059,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_823_10957)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.041 66.0479C146.041 66.0479 94.7079 80.3868 64.9952 46.6096C35.2824 12.8323 -0.715256 68.3467 -0.715256 68.3467C-0.715256 68.3467 -7.38997 147.325 1.53799 147.325H127.218L146.041 66.0479Z",
    fill: "#870A3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_823_10957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 4,
    width: 49,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8228 4.49219H79.9019V64.6153H31.8228V4.49219Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_823_10957)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0838 28.9405H63.1056C63.7948 29.1057 84.3866 40.2099 70.7373 53.0162C57.7575 65.1949 43.6807 67.5774 37.1766 61.1302C23.5513 47.6259 39.626 30.4356 44.7363 25.7654C46.3351 24.3033 49.4759 21.0137 50.1891 15.0839C50.2763 14.3683 53.2601 15.0443 53.9057 18.1314C54.3724 20.3641 53.9515 22.8148 53.9711 23.7991C53.9711 23.962 74.6611 0.685664 79.2458 5.03223C83.9853 9.52412 61.4414 26.8091 63.0838 28.9405Z",
    fill: "#914420"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0795 28.9535C63.0795 28.9535 68.5279 26.0051 73.7843 25.8664C81.235 25.6726 78.9885 24.9174 81.0823 23.8252C84.21 22.198 80.6679 45.2344 80.6679 45.2344C80.6679 45.2344 80.1183 48 70.3687 53.1987C70.3687 53.1987 73.7124 45.3313 65.9193 38.5582C59.7969 33.2384 63.0795 28.9535 63.0795 28.9535Z",
    fill: "#6A3113"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7865 38.3664C55.0688 48.6119 39.2776 39.2472 50.2377 30.7434C53.18 28.4688 53.8496 24.8423 53.9717 23.7986C53.9717 23.9615 53.9914 24.0628 54.0328 24.0628C54.0328 24.0628 54.0743 24.0232 54.155 23.9615C55.8191 29.4333 59.8171 30.7038 57.7865 38.3664Z",
    fill: "#6A3113"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5933 8.68579C54.5933 8.68579 54.1898 4.92493 57.7472 5.03943L78.6466 6.49709C78.6466 6.49709 82.0905 6.33855 81.7415 9.5137L78.3194 59.5697C78.3194 59.5697 78.4154 61.9786 75.7762 61.9257L54.2204 60.4218C54.2204 60.4218 51.0948 60.3381 51.2279 57.1476L54.5933 8.68579Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7365 58.8931C63.5652 58.8116 62.6819 57.7855 62.7626 56.6009C62.8433 55.4185 63.8597 54.5267 65.0309 54.6082C66.2043 54.6897 67.0877 55.7158 67.007 56.8982C66.9263 58.0806 65.9099 58.9746 64.7365 58.8931Z",
    fill: "#FF780F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0754 9.86413C66.6959 9.83771 66.4102 9.50742 66.4385 9.12429C66.4647 8.74336 66.7919 8.45491 67.1714 8.48133C67.5487 8.50776 67.8344 8.83804 67.8083 9.22117C67.7821 9.6021 67.4549 9.89055 67.0754 9.86413Z",
    fill: "#FF780F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5684 9.66832C68.3525 9.6529 68.1911 9.46574 68.2064 9.24775C68.2216 9.02976 68.4092 8.86682 68.623 8.88224C68.8367 8.89765 69.0003 9.08481 68.985 9.3028C68.9719 9.51859 68.7844 9.68373 68.5684 9.66832Z",
    fill: "#FF780F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3762 11.2437L56.012 11.3537L81.4873 13.1373L80.3749 29.5195V29.6296L78.7827 52.8817L72.8697 52.4854L51.6498 50.9881L52.6313 36.7638L54.3762 11.2437Z",
    fill: "#FF780F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3125 38.3108C65.1949 39.4733 61.8916 38.7962 57.1917 38.4623C56.1836 38.3906 56.3352 37.1204 57.201 37.1819C61.4003 37.4803 65.4195 37.2506 65.3125 38.3108ZM65.7336 32.2267C65.616 33.3896 62.3127 32.7122 57.6128 32.3782C56.6047 32.3066 56.7563 31.0364 57.6221 31.0979C61.8214 31.3963 65.8406 31.1669 65.7336 32.2267ZM66.1551 26.143C66.0374 27.3055 62.7341 26.6284 58.0343 26.2945C57.0262 26.2229 57.1777 24.9526 58.0435 25.0141C62.2429 25.3125 66.2621 25.0828 66.1551 26.143ZM66.5598 20.2995C66.4421 21.4625 63.1388 20.785 58.439 20.451C57.4309 20.3794 57.5824 19.1095 58.4482 19.1711C62.6476 19.4694 66.6668 19.2394 66.5598 20.2995ZM70.9471 35.6899C70.7688 37.1342 67.8466 35.7604 57.4012 35.4351C56.3911 35.4038 56.5423 34.1599 57.4104 34.1559C68.7008 34.1048 71.0899 34.5323 70.9471 35.6899ZM71.3563 29.778C71.178 31.2223 68.2558 29.8485 57.8104 29.5232C56.8003 29.4922 56.9515 28.2479 57.8197 28.2436C69.11 28.1928 71.4991 28.6204 71.3563 29.778ZM71.7659 23.866C71.5876 25.31 68.6654 23.9365 58.22 23.6112C57.2099 23.5799 57.3611 22.3356 58.2293 22.3316C69.5196 22.2808 71.9087 22.7084 71.7659 23.866ZM76.2173 38.5802C76.0788 39.6261 74.5311 39.169 74.1761 39.1437C73.1678 39.072 73.319 37.7996 74.1853 37.8613C74.5546 37.8875 76.3512 37.5657 76.2173 38.5802ZM76.4191 35.6638C76.2806 36.7094 74.733 36.2523 74.378 36.227C73.3696 36.1553 73.5208 34.8836 74.3871 34.9453C74.7564 34.9715 76.5531 34.649 76.4191 35.6638ZM76.6213 32.7475C76.4828 33.7931 74.9351 33.3363 74.5801 33.311C73.5718 33.2393 73.723 31.9669 74.5893 32.0286C74.9586 32.0549 76.7552 31.7331 76.6213 32.7475ZM76.8231 29.8308C76.6846 30.8767 75.1369 30.4196 74.7819 30.3943C73.7736 30.3226 73.9249 29.0502 74.7912 29.1118C75.1605 29.1381 76.957 28.8163 76.8231 29.8308ZM77.0253 26.9144C76.8868 27.9603 75.3391 27.5032 74.9841 27.4779C73.9758 27.4062 74.127 26.1338 74.9933 26.1954C75.3626 26.2217 77.1592 25.8999 77.0253 26.9144ZM77.2271 23.9981C77.0886 25.0436 75.5409 24.5869 75.1859 24.5616C74.1776 24.4899 74.3288 23.2175 75.1952 23.2791C75.5645 23.3054 77.361 22.9836 77.2271 23.9981ZM77.4293 21.0813C77.2908 22.1272 75.7431 21.6701 75.3881 21.6449C74.3798 21.5731 74.531 20.3011 75.3973 20.3627C75.7666 20.389 77.5632 20.0669 77.4293 21.0813ZM77.6311 18.1649C77.4926 19.2109 75.9449 18.7537 75.5899 18.7285C74.5816 18.6567 74.7328 17.3844 75.5992 17.446C75.9685 17.4723 77.765 17.1505 77.6311 18.1649ZM72.1874 17.7823C72.0091 19.2266 69.0869 17.8524 58.6415 17.5275C57.6313 17.4962 57.7826 16.2523 58.6507 16.2479C69.9411 16.1972 72.3302 16.6243 72.1874 17.7823Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2205 46.4537C47.9087 46.2776 51.043 49.1555 51.2153 52.8789C51.3898 56.6045 48.5391 59.7665 44.8508 59.9426C41.1626 60.1188 38.0283 57.2409 37.8539 53.5174C37.6815 49.7918 40.5323 46.6299 44.2205 46.4537Z",
    fill: "#914420"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_823_10957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 22,
    width: 10,
    height: 26
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4191 22.9714H85.6372V47.3719H76.4191V22.9714Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_823_10957)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.05 47.3C80.7927 47.7184 81.9683 46.2541 82.5856 44.3737C83.7765 40.756 81.9989 39.9457 81.5299 39.3732C86.095 38.4704 85.1069 32.0628 82.6248 32.043C87.2139 31.2834 86.0295 22.9756 82.6096 22.9756C79.2965 22.7884 77.6017 29.022 79.9726 31.4881C77.9987 30.9509 73.7194 36.8652 78.8515 38.946C76.8035 40.1901 75.0608 46.34 79.05 47.3Z",
    fill: "#914420"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2596 45.6688C19.5644 63.4403 7.964 74.8186 2.8148 91.7372C-1.66703 106.481 17.3922 123.115 29.1431 106.62C40.894 90.124 42.3269 72.3194 49.7006 59.0172C49.7006 59.0371 48.9613 27.9038 34.2596 45.6688Z",
    fill: "#914420"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_823_10957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 29,
    width: 35,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3625 29.78L96.4909 32.6177L94.4741 55.8897L62.3458 53.052L64.3625 29.78Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_823_10957)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7332 50.7307C67.2075 50.8414 60.5317 43.0562 64.5068 41.0228C68.4843 38.9909 68.9718 44.9653 72.8793 45.0534C76.7868 45.1415 78.6367 39.5706 91.9671 32.8065C95.7379 30.8932 97.5579 35.007 93.8172 36.4233C82.9223 40.5496 78.2589 50.62 72.7332 50.7307Z",
    fill: "#640032"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCheck);
export default __webpack_public_path__ + "static/media/phone-check.d234620c1f4a9d4ccf12068ffc141c77.svg";
export { ForwardRef as ReactComponent };